/**
 * DDI Mega Nav — Desktop hover-driven panels + GSAP animations
 * Mirrors the Replit prototype's mouseenter/mouseleave with 150ms timeout.
 * Panels animate with GSAP (opacity + y shift), matching Framer Motion behavior.
 * Search overlay triggers are preserved from the original navbar.js.
 */
function initMegaNav() {
    var header = document.getElementById('megaNav');
    if (!header) return;

    var items = header.querySelectorAll('.mega-nav__item');
    var panels = header.querySelectorAll('.mega-panel');
    var backdrop = document.getElementById('megaPanelBackdrop');
    var closeTimeout = null;
    var activeSection = null;

    // Map data-section -> panel id
    function getPanelForSection(section) {
        return document.getElementById('panel-' + section);
    }

    function openPanel(section) {
        if (closeTimeout) {
            clearTimeout(closeTimeout);
            closeTimeout = null;
        }

        if (activeSection === section) return;

        // Close previous
        if (activeSection) {
            closePanelImmediate(activeSection);
        }

        activeSection = section;
        var panel = getPanelForSection(section);
        if (!panel) return;

        // Mark button active
        items.forEach(function (item) {
            var btn = item.querySelector('.mega-nav__item-btn');
            if (item.getAttribute('data-section') === section) {
                btn.classList.add('is-active');
            } else {
                btn.classList.remove('is-active');
            }
        });

        // Show backdrop
        if (backdrop) {
            backdrop.classList.add('is-open');
            gsap.fromTo(backdrop, { opacity: 0 }, { opacity: 1, duration: 0.15 });
        }

        // Show panel
        panel.classList.add('is-open');
        gsap.fromTo(panel,
            { opacity: 0, y: -4 },
            { opacity: 1, y: 0, duration: 0.2, ease: 'power2.out' }
        );
    }

    function closePanelImmediate(section) {
        var panel = getPanelForSection(section);
        if (panel) {
            gsap.to(panel, {
                opacity: 0, y: -4, duration: 0.15, ease: 'power2.in',
                onComplete: function () {
                    panel.classList.remove('is-open');
                }
            });
        }
    }

    function closeAll() {
        activeSection = null;

        items.forEach(function (item) {
            item.querySelector('.mega-nav__item-btn').classList.remove('is-active');
        });

        panels.forEach(function (panel) {
            if (panel.classList.contains('is-open')) {
                gsap.to(panel, {
                    opacity: 0, y: -4, duration: 0.15, ease: 'power2.in',
                    onComplete: function () {
                        panel.classList.remove('is-open');
                    }
                });
            }
        });

        if (backdrop) {
            gsap.to(backdrop, {
                opacity: 0, duration: 0.15,
                onComplete: function () {
                    backdrop.classList.remove('is-open');
                }
            });
        }
    }

    // Desktop: hover open with 150ms close delay
    items.forEach(function (item) {
        var section = item.getAttribute('data-section');
        var btn = item.querySelector('.mega-nav__item-btn');

        item.addEventListener('mouseenter', function () {
            openPanel(section);
        });

        btn.addEventListener('mouseenter', function () {
            openPanel(section);
        });

        // Click toggle for accessibility
        btn.addEventListener('click', function () {
            if (activeSection === section) {
                closeAll();
            } else {
                openPanel(section);
            }
        });
    });

    // Keep panel open when hovering over it
    panels.forEach(function (panel) {
        panel.addEventListener('mouseenter', function () {
            if (closeTimeout) {
                clearTimeout(closeTimeout);
                closeTimeout = null;
            }
        });

        panel.addEventListener('mouseleave', function () {
            closeTimeout = setTimeout(closeAll, 150);
        });
    });

    // Close on header mouseleave (with delay)
    header.addEventListener('mouseleave', function () {
        if (activeSection) {
            closeTimeout = setTimeout(closeAll, 150);
        }
    });

    header.addEventListener('mouseenter', function () {
        // Cancel close if re-entering header area
        if (closeTimeout) {
            clearTimeout(closeTimeout);
            closeTimeout = null;
        }
    });

    // Close on backdrop click
    if (backdrop) {
        backdrop.addEventListener('click', function () {
            closeAll();
        });
    }

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && activeSection) {
            closeAll();
        }
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaNav);
} else {
    initMegaNav();
}
